import QuoteMessageNonFeasible from './QuoteMessageNonFeasible.styled';

export default QuoteMessageNonFeasible;
